import codes from "../../../errorCodes/Team"

export default function tenantErrorHandler(errorCode: string) {
  switch (errorCode) {
    case codes.TeamNotFoundErr:
      return "errors.PBIDETeamNotFound"
    case codes.TeamDoesNotBelong:
      return "errors.PBIDETeamDoesNotBelong"
    case codes.PublicNameAlreadyExists:
      return "errors.PBIDEPublicNameAlreadyExists"
    case codes.PublicNameTooShort:
      return "errors.PBIDEPublicNameTooShort"
    case codes.PublicNameTooLong:
      return "errors.PBIDEPublicNameTooLong"
    case codes.PublicNameInvalid:
      return "errors.PBIDEPublicNameInvalid"
    case codes.TenantCannotBeChanged:
      return "errors.PBIDETenantCannotBeChanged"
    default:
      return ""
  }
}
